var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 45,
    viewBox: "0 0 152 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.125 43.6983H7.50482C4.16719 43.6983 1.3735 41.1424 1.3735 37.9442V7.13512C1.3735 3.93699 4.16719 1.38106 7.50482 1.38106H145.125C148.463 1.38106 151.257 3.93699 151.257 7.13512V37.9442C151.257 41.1424 148.463 43.6983 145.125 43.6983Z",
    stroke: "white",
    strokeOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2339 13.7516C51.2339 14.5465 50.9902 15.1832 50.51 15.658C49.9578 16.2208 49.2388 16.504 48.3576 16.504C47.5154 16.504 46.7963 16.216 46.2064 15.6484C45.6153 15.0725 45.3203 14.3657 45.3203 13.5196C45.3203 12.6735 45.6153 11.9667 46.2064 11.3955C46.7963 10.8231 47.5154 10.5352 48.3576 10.5352C48.7768 10.5352 49.1766 10.6196 49.5581 10.7767C49.9383 10.935 50.2479 11.1492 50.4722 11.4133L49.9627 11.9155C49.5715 11.4645 49.0389 11.242 48.3576 11.242C47.7433 11.242 47.2107 11.4514 46.7585 11.8739C46.3112 12.2975 46.0869 12.8461 46.0869 13.5196C46.0869 14.1931 46.3112 14.7464 46.7585 15.1701C47.2107 15.5877 47.7433 15.8019 48.3576 15.8019C49.0096 15.8019 49.5581 15.5877 49.9908 15.1653C50.2759 14.8857 50.4381 14.5001 50.4807 14.0075H48.3576V13.3197H51.19C51.2242 13.4684 51.2339 13.6124 51.2339 13.7516V13.7516Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7264 11.3669H53.0657V13.1756H55.4643V13.8634H53.0657V15.6722H55.7264V16.3731H52.3125V10.666H55.7264V11.3669Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9008 16.3731H58.1476V11.3669H56.5156V10.666H60.534V11.3669H58.9008V16.3731V16.3731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4414 16.3731V10.666H64.1934V16.3731H63.4414Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5258 16.3731H66.7787V11.3669H65.1406V10.666H69.1639V11.3669H67.5258V16.3731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.773 15.6389C76.1965 16.216 75.4822 16.504 74.6303 16.504C73.7735 16.504 73.0593 16.216 72.4828 15.6389C71.9075 15.063 71.6211 14.3561 71.6211 13.5196C71.6211 12.683 71.9075 11.9762 72.4828 11.4003C73.0593 10.8231 73.7735 10.5352 74.6303 10.5352C75.4774 10.5352 76.1916 10.8231 76.7681 11.405C77.3482 11.9857 77.6347 12.6878 77.6347 13.5196C77.6347 14.3561 77.3482 15.063 76.773 15.6389ZM73.0398 15.1605C73.4737 15.5877 74.0014 15.8019 74.6303 15.8019C75.2543 15.8019 75.7869 15.5877 76.216 15.1605C76.6486 14.7333 76.868 14.1848 76.868 13.5196C76.868 12.8544 76.6486 12.3058 76.216 11.8786C75.7869 11.4514 75.2543 11.2372 74.6303 11.2372C74.0014 11.2372 73.4737 11.4514 73.0398 11.8786C72.6071 12.3058 72.3877 12.8544 72.3877 13.5196C72.3877 14.1848 72.6071 14.7333 73.0398 15.1605V15.1605Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6875 16.3731V10.666H79.6016L82.4438 15.1046H82.4767L82.4438 14.0074V10.666H83.1958V16.3731H82.4109L79.4346 11.7156H79.4017L79.4346 12.8175V16.3731H78.6875V16.3731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4343 24.7084C69.1442 24.7084 67.2733 26.41 67.2733 28.7578C67.2733 31.0866 69.1442 32.8061 71.4343 32.8061C73.7293 32.8061 75.6001 31.0866 75.6001 28.7578C75.6001 26.41 73.7293 24.7084 71.4343 24.7084ZM71.4343 31.2115C70.1777 31.2115 69.0966 30.1989 69.0966 28.7578C69.0966 27.2977 70.1777 26.3029 71.4343 26.3029C72.6909 26.3029 73.7768 27.2977 73.7768 28.7578C73.7768 30.1989 72.6909 31.2115 71.4343 31.2115V31.2115ZM62.3555 24.7084C60.0605 24.7084 58.1945 26.41 58.1945 28.7578C58.1945 31.0866 60.0605 32.8061 62.3555 32.8061C64.6492 32.8061 66.5164 31.0866 66.5164 28.7578C66.5164 26.41 64.6492 24.7084 62.3555 24.7084ZM62.3555 31.2115C61.0977 31.2115 60.0129 30.1989 60.0129 28.7578C60.0129 27.2977 61.0977 26.3029 62.3555 26.3029C63.612 26.3029 64.6931 27.2977 64.6931 28.7578C64.6931 30.1989 63.612 31.2115 62.3555 31.2115ZM51.552 25.9495V27.6702H55.7605C55.6374 28.6317 55.3084 29.3385 54.8038 29.8312C54.1895 30.4261 53.2328 31.0866 51.552 31.0866C48.9621 31.0866 46.934 29.0458 46.934 26.5171C46.934 23.9884 48.9621 21.9476 51.552 21.9476C52.9524 21.9476 53.9714 22.4819 54.7234 23.1745L55.9653 21.9619C54.9135 20.9814 53.5143 20.2281 51.552 20.2281C48.0005 20.2281 45.0156 23.0496 45.0156 26.5171C45.0156 29.9847 48.0005 32.8061 51.552 32.8061C53.4716 32.8061 54.9135 32.192 56.047 31.0402C57.2085 29.9061 57.5705 28.3116 57.5705 27.024C57.5705 26.6242 57.5363 26.2565 57.4754 25.9495H51.552ZM95.7286 27.2834C95.3861 26.3779 94.3294 24.7084 92.177 24.7084C90.0441 24.7084 88.2683 26.3493 88.2683 28.7578C88.2683 31.0259 90.0258 32.8061 92.3818 32.8061C94.2868 32.8061 95.3861 31.672 95.8383 31.0116L94.4245 30.0918C93.9528 30.7653 93.3105 31.2115 92.3818 31.2115C91.4591 31.2115 90.7973 30.7986 90.3732 29.9847L95.9199 27.744L95.7286 27.2834V27.2834ZM90.0734 28.6317C90.0258 27.0704 91.3153 26.2708 92.2392 26.2708C92.9631 26.2708 93.5774 26.6242 93.7822 27.1299L90.0734 28.6317V28.6317ZM85.565 32.5597H87.3884V20.6601H85.565V32.5597ZM82.579 25.6104H82.518C82.1085 25.1367 81.3273 24.7084 80.3376 24.7084C78.2608 24.7084 76.3619 26.4885 76.3619 28.7709C76.3619 31.0402 78.2608 32.8061 80.3376 32.8061C81.3273 32.8061 82.1085 32.3741 82.518 31.8862H82.579V32.4669C82.579 34.0151 81.7319 34.8469 80.3656 34.8469C79.2517 34.8469 78.5606 34.0615 78.2754 33.401L76.6897 34.0472C77.1468 35.1205 78.3571 36.4414 80.3656 36.4414C82.5034 36.4414 84.3072 35.2134 84.3072 32.2254V24.9547H82.579V25.6104V25.6104ZM80.4936 31.2115C79.237 31.2115 78.1852 30.1846 78.1852 28.7709C78.1852 27.3441 79.237 26.3029 80.4936 26.3029C81.7319 26.3029 82.7082 27.3441 82.7082 28.7709C82.7082 30.1846 81.7319 31.2115 80.4936 31.2115V31.2115ZM104.265 20.6601H99.9042V32.5597H101.723V28.051H104.265C106.285 28.051 108.265 26.6242 108.265 24.3549C108.265 22.0869 106.28 20.6601 104.265 20.6601V20.6601ZM104.313 26.3957H101.723V22.3153H104.313C105.67 22.3153 106.445 23.4161 106.445 24.3549C106.445 25.276 105.67 26.3957 104.313 26.3957ZM115.554 24.6858C114.24 24.6858 112.873 25.2522 112.312 26.5076L113.925 27.168C114.273 26.5076 114.911 26.2934 115.586 26.2934C116.53 26.2934 117.487 26.8467 117.501 27.8237V27.9486C117.172 27.763 116.468 27.4881 115.601 27.4881C113.863 27.4881 112.092 28.4222 112.092 30.1655C112.092 31.7601 113.516 32.787 115.116 32.787C116.34 32.787 117.015 32.248 117.439 31.6209H117.501V32.5407H119.257V27.976C119.257 25.8662 117.644 24.6858 115.554 24.6858ZM115.334 31.2068C114.739 31.2068 113.911 30.9188 113.911 30.1989C113.911 29.2778 114.944 28.9244 115.839 28.9244C116.64 28.9244 117.015 29.0969 117.501 29.3242C117.359 30.4261 116.387 31.2068 115.334 31.2068V31.2068ZM125.656 24.9464L123.566 30.1048H123.504L121.343 24.9464H119.382L122.629 32.1552L120.776 36.1665H122.676L127.679 24.9464H125.656V24.9464ZM109.265 32.5597H111.088V20.6601H109.265V32.5597Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1748 11.1781C11.8884 11.4709 11.7227 11.9266 11.7227 12.5168V33.5697C11.7227 34.1599 11.8884 34.6157 12.1748 34.9084L12.2455 34.9727L24.3287 23.1801V22.9017L12.2455 11.1091L12.1748 11.1781Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3514 27.1113L24.3281 23.1785V22.9L28.3563 18.9672L28.4464 19.0184L33.2168 21.6684C34.5782 22.4205 34.5782 23.6581 33.2168 24.4149L28.4464 27.0602L28.3514 27.1113V27.1113Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.448 27.0603L24.3296 23.0394L12.1758 34.9069C12.628 35.371 13.3653 35.4269 14.2039 34.9628L28.448 27.0603",
    fill: "url(#paint2_linear_0_1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.448 19.0192L14.2039 11.1166C13.3653 10.6573 12.628 10.7132 12.1758 11.1773L24.3296 23.04L28.448 19.0192Z",
    fill: "url(#paint3_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 23.2558,
    y1: 33.7889,
    x2: 7.28406,
    y2: 17.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 34.9896,
    y1: 23.0379,
    x2: 11.3967,
    y2: 23.0379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 26.2085,
    y1: 20.8536,
    x2: 4.5495,
    y2: -1.33031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 9.1164,
    y1: 41.9117,
    x2: 18.7881,
    y2: 32.0057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.2436eca354a24e08df6f56466ed7e88e.svg";
export { ForwardRef as ReactComponent };